// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox__checkbox___2dGFj","label":"checkbox__label___3A6Bj","disabled":"checkbox__disabled___CfZh4","checkboxContainer":"checkbox__checkboxContainer___38bTx"};